// components/RcsSuggestionIconsRow.jsx
import React from "react";
import { Stack, Tooltip, Chip } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import PhoneIcon from "@mui/icons-material/Phone";
import BoltIcon from "@mui/icons-material/Bolt";

function RcsSuggestionIconsRow({ suggestions = [], spacing = 0.5, sx }) {
  if (!Array.isArray(suggestions) || suggestions.length === 0) return null;

  const getIcon = (type) => {
    switch (type) {
      case "OPEN_URL":
        return <LinkIcon fontSize="small" />;
      case "DIAL_PHONE":
        return <PhoneIcon fontSize="small" />;
      default:
        return <BoltIcon fontSize="small" />;
    }
  };

  const getTooltipValue = (s) => {
    if (!s) return "";
    if (s.type === "OPEN_URL") return s.url || "";
    if (s.type === "DIAL_PHONE") return s.phoneNumber || "";
    return s.postbackData || "";
  };

  return (
    <Stack
      direction="row"
      spacing={spacing}
      alignItems="center"
      flexWrap="wrap"
      sx={sx}
    >
      {suggestions.map((s, i) => (
        <Tooltip key={i} title={getTooltipValue(s)} arrow enterDelay={300}>
          <Chip
            icon={getIcon(s.type)}
            label={s.text || s.type}
            size="small"
            sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "#fff", cursor: "pointer" }}

          />
        </Tooltip>
      ))}
    </Stack>
  );
}

export default React.memo(RcsSuggestionIconsRow);
